export const environment = {
  production: false,
  url: "https://api-berjayasompo-crm.policystreet.app",
};
